export interface PresetImage {
  id: string;
  name: string;
  url: string;
  description: string;
}

export const presetImages: PresetImage[] = [
  {
    id: 'happy-birthday',
    name: 'Happy Birthday',
    url: 'https://blossom.ditto.pub/ddb81416cf0c8b73ce5bac693e5d7776cb8125928f9a07c7ddef85b951b693e4.jpeg',
    description: 'Birthday peanut character with party hat',
  },
  {
    id: 'you-got-ecash',
    name: 'You Got eCash',
    url: 'https://blossom.ditto.pub/c67449de2a36f227345855228f3cd228d7e65dde9f11df4b9463fab0ce7f1896.jpeg',
    description: 'Fun peanut character with sunglasses and a crown',
  },
  {
    id: 'happy-bday-bitcoin',
    name: 'Happy ₿ Day',
    url: 'https://blossom.dreamith.to/af55c188de24b41b707637b6fbe87b3be7dc90d48df4f1250b38ecad5388e9f5.png',
    description: 'Hand-drawn Happy Birthday with Bitcoin symbol',
  },
  {
    id: 'stack-nuts',
    name: 'Stack Nuts',
    url: 'https://blossom.dreamith.to/953a886a6e6a96747d82b0accc66b4ae1a6fdd4f3526ba72b90bdbfc588adebc.png',
    description: 'Hand-painted Stack Nuts in purple and orange',
  },
  {
    id: 'thank-you',
    name: 'Thank You',
    url: 'https://blossom.dreamith.to/5878f0bf79befa33ca0b3980b3bf97a2c23428932d9ef0239edd27f21de10606.png',
    description: 'Hand-drawn Thank You lettering',
  },
  {
    id: 'stack-nuts-outline',
    name: 'Stack Nuts B&W',
    url: 'https://blossom.dreamith.to/babb2ccbd60aaf18474b220b6b7c2dd0363bd60073ef40d3d044c9afec785af5.png',
    description: 'Hand-drawn Stack Nuts outline lettering',
  },
];

/** Fixed back cover image (Cashu Cards branding + redeem URL) — always used */
export const BACK_COVER_URL = 'https://blossom.dreamith.to/1d67b4b450b073a2ed1b3ae5dead707e31e262685522bd4d21999ba27a11d1e1.png';

/** The Cashu Cards logo used on the inside QR page */
export const REDEEM_IMAGE_URL = 'https://blossom.dreamith.to/1d67b4b450b073a2ed1b3ae5dead707e31e262685522bd4d21999ba27a11d1e1.png';
